import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar, HeartCrack } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-alert-light/30" data-id="element-145">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-147">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-alert-light text-alert font-bold text-sm mb-4" data-id="element-148">
            <span className="w-2 h-2 rounded-full bg-alert animate-pulse" data-id="element-149"></span>
            Alerta · Costo oculto
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-150">
            Dejá de pagar con tu tiempo libre.
          </h2>
          <p className="text-xl text-gray-600" data-id="element-151">
            El verdadero costo oculto de improvisar la consulta:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-alert-light text-center" data-id="element-153">
            <div className="w-16 h-16 mx-auto bg-alert-light rounded-full flex items-center justify-center mb-6" data-id="element-154">
              <Clock className="w-8 h-8 text-alert" data-id="element-155" />
            </div>
            <h3 className="text-3xl font-black text-alert mb-2" data-id="element-156">+100hrs</h3>
            <p className="text-gray-900 font-bold mb-1" data-id="element-157">Perdidas al año</p>
            <p className="text-gray-500 text-sm" data-id="element-158">de tu vida personal</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-alert-light text-center" data-id="element-159">
            <div className="w-16 h-16 mx-auto bg-alert-light rounded-full flex items-center justify-center mb-6" data-id="element-160">
              <Calendar className="w-8 h-8 text-alert" data-id="element-161" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-162">
              2 a 4 horas por semana
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-163">
              armando materiales y explicaciones a mano.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-alert-light text-center" data-id="element-164">
            <div className="w-16 h-16 mx-auto bg-alert-light rounded-full flex items-center justify-center mb-6" data-id="element-165">
              <HeartCrack className="w-8 h-8 text-alert" data-id="element-166" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-167">
              Fines de semana, noches y familia
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-168">tiempo que ya no vuelve.</p>
          </motion.div>
        </div>
      </div>
    </section>;
}